import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-zinc-900" data-id="element-177">
      <div className="container mx-auto px-4" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-180">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-zinc-200 text-[16px]" data-id="element-181">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-182">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-black/80 rounded-3xl p-8 shadow-2xl border border-emerald-900/40 flex flex-col h-full" data-id="element-183">
            <div className="mb-6" data-id="element-184">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-185">
                🇧🇷 MEGAPACK PORTUGUÉS LISTO
              </h3>
              <p className="text-emerald-300 font-bold" data-id="element-186">6 Tomos + 4 Bonus</p>
            </div>

            <div className="mb-6 pb-6 border-b border-emerald-900/30" data-id="element-187"></div>

            <div className="mb-8" data-id="element-188">
              <div className="flex items-end gap-2" data-id="element-189">
                <span className="text-5xl font-black text-white" data-id="element-190">$19.990</span>
                <span className="text-xl font-bold text-emerald-300 mb-1" data-id="element-191">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-192">
              {['6 Tomos completos', '4 Bonus estratégicos', '500+ páginas', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-193">
                  <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-194" />
                  <span className="text-zinc-100" data-id="element-195">{feature}</span>
                </li>)}
            </ul>

            <a href="https://portugueslisto.shop/cart/47729181065410:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-196">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-197">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black rounded-3xl p-8 shadow-2xl border-2 border-emerald-400 flex flex-col h-full relative lg:scale-105 z-10" data-id="element-198">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-emerald-400 text-black px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-199">
              <Star className="w-4 h-4 fill-black" data-id="element-200" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-201">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-202">
                ⚡ MEGAPACK + NIVEL PRO
              </h3>
              <p className="text-emerald-400 font-bold text-[14px]" data-id="element-203">
                Todo lo anterior + Sistema Profesional por Industria
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-emerald-900/30" data-id="element-204"></div>

            <div className="mb-8" data-id="element-205">
              <div className="flex items-end gap-2" data-id="element-206">
                <span className="text-5xl font-black text-white" data-id="element-207">$27.990</span>
                <span className="text-xl font-bold text-zinc-400 mb-1" data-id="element-208">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-209">
              <li className="flex items-start gap-3" data-id="element-210">
                <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-211" />
                <span className="text-white font-bold" data-id="element-212">
                  Todo lo del Megapack base, MÁS:
                </span>
              </li>
              {['Portugués para IT y Tecnología', 'Portugués para Marketing Digital', 'Portugués para Finanzas y Negocios', 'Portugués para RRHH y Consultoría', 'Portugués para Exportación e Importación', 'Comunicación Intercultural Argentina-Brasil', 'Plan PRO 60 días + Certificación PRO', 'Scripts de presentaciones, pitches y negociaciones'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
                  <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-214" />
                  <span className="text-zinc-300" data-id="element-215">{feature}</span>
                </li>)}
            </ul>

            <a href="https://portugueslisto.shop/cart/47729196531906:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-216">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-217">
                ⚡ QUIERO EL MEGAPACK + NIVEL PRO
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}